/* eslint-disable  react/display-name */
import {
  Grid,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  getCardContentUtilityClass,
} from "@mui/material";
import PermMediaOutlinedIcon from "@mui/icons-material/PermMediaOutlined";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { PricingUtils } from "../../utils/PricingUtils";
import { SaleUtils } from "../../utils/SaleUtils";
import OpenPriceDialog from "./OpenPriceDialog";
import { OpenQtyDialog } from "./OpenQtyDialog";
import { AgentUtils } from "../../utils/AgentUtils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { orange, red, teal, yellow } from "@mui/material/colors";
import PText from "../../components/pos/PText";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/AddCircleTwoTone";
import RemoveIcon from "@mui/icons-material/RemoveCircleTwoTone";

const theme = createTheme({
  components: {
    MuiInputBase: {
      input: {
        fontSize: "1.9rem",
        fontWeight: "bold",
        padding: 2,
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: 2,
        marginLeft: 2,
      },
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        input: {
          padding: 2,
          marginLeft: 2,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: ".95rem",
          padding: "5px",
        },
        head: {
          lineHeight: "2rem",
          fontSize: "1rem",
          padding: 0,
          color: "#fff",
          backgroundColor: "#00695c !important",
        },
        paddingCheckbox: {
          width: 0,
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: {
          "&:nth-child(odd)": {
            backgroundColor: yellow[50],
          },
        },
      },
    },
  },
});

const r_pos_desktop_theme = createTheme({
  components: {
    MuiInputBase: {
      input: {
        fontSize: "1.9rem",
        fontWeight: "bold",
        padding: 2,
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: 2,
        marginLeft: 2,
      },
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        input: {
          padding: 2,
          marginLeft: 2,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: ".9rem",
          padding: "5px",
        },
        head: {
          lineHeight: "2rem",
          fontSize: "0.9rem",
          padding: 0,
          color: "#fff",
          backgroundColor: "#00695c !important",
        },
        paddingCheckbox: {
          width: 0,
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: {
          "&:nth-child(odd)": {
            backgroundColor: yellow[50],
          },
        },
      },
    },
  },
});

export default function SaleList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [ref, setRef] = useState(null);
  const [showServiceWindow, setShowServiceWindow] = useState(false);

  const [openFileViewWindow, setOpenFileViewWindow] = useState(false);
  const [previewFileList, setPreviewFileList] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleClick(event, value) {
    setAnchorEl(event.currentTarget);
  }

  const inputRef = useRef([]);

  var biRef = {};

  props.biRef.saleList = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    if (event === "onAddProduct") {
      preProcess(value1, value2, null, value3);
    } else if (event === "onBarcodeScanned") {
      if (value1.length > 0) preProcess(null, null, value1);
    } else if (event === "updateQty") {
      if (value1 == "0" || parseFloat(value1) == 0) {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate("Zero Quantity not allowed"),
        });
        return;
      }
      if (!isNaN(value1) && value1 != "") {
        let position = getCurrentRow();
        if (position >= 0) updateProduct(position, "updateQty", value1);
      }
    } else if (event === "updatePrice") {
      if (!isNaN(value1) && value1 != "") {
        let position = getCurrentRow();
        if (position >= 0) updateProduct(position, "updatePrice", value1);
      }
    } else if (event === "updateDiscountPer") {
      if (!isNaN(value1) && value1 != "") {
        let position = getCurrentRow();
        if (position >= 0) updateProduct(position, "updateDiscountPer", value1);
      }
    } else if (event === "updateDiscountAmount") {
      if (!isNaN(value1) && value1 != "") {
        let position = getCurrentRow();
        if (position >= 0)
          updateProduct(position, "updateDiscountAmount", value1);
      }
    } else if (event === "onKeyPressed") {
      if (value1 == "ArrowUp") moveUp();
      if (value1 == "ArrowDown") moveDown();
      if (value1 == "Delete") {
        if (props.privileges.remove_buttun_allowed) {
          removeItem();
        }
      }
    } else if (event === "updateCustomerPriceLevel") {
      updateCustomerPriceLevel(value1);
    } else if (event === "deleteItem") {
      if (props.privileges.remove_buttun_allowed) {
        removeItem();
      }
    } else if (event === "populateItems") {
      populateItems(value1);
    } else if (event === "modifyServiceDetails") {
      modifyServiceDetails();
    } else if (event === "removeRawData") {
      removeRawData(value1);
    }
  }

  function modifyServiceDetails() {
    let position = getCurrentRow();
    if (position >= 0) {
      props.setServiceDataMode("update");
      setShowServiceWindow(true);
    }
  }

  async function populateItems(saleBean) {
    let rawData = [];
    for (let i = 0; i < saleBean.saleItemBeanList.length; i++) {
      let item = saleBean.saleItemBeanList[i];
      let key = SaleUtils.deriveKey(
        props.data,
        props.data,
        item.productId,
        item.pricingUnitType,
        item.isReturn,
        "DELI" + (props.data.length + 1)
      );

      let pricingBean = getPricingFromUnitType(
        item.productBean,
        item.pricingUnitType
      );
      let productBean = item.productBean;
      let price = item.price;
      let qty = item.quantity;
      let returnFlag = false;
      // let key = key;
      let extax = null;

      if (pricingBean) {
        if (
          productBean.kitItems != null &&
          productBean.kitItems != undefined &&
          productBean.isKit != null &&
          productBean.isKit != undefined &&
          productBean.isExpandKitDuringSale != null &&
          productBean.isExpandKitDuringSale != undefined &&
          productBean.isExpandKitDuringSale == true
        ) {
          for (let i = 0; i < productBean.kitItems.length; i++) {
            let dbData = await db.product
              .where("id")
              .equals(productBean.kitItems[i].productId)
              .toArray();
            if (dbData[0] != null && dbData[0] != undefined) {
              let key = SaleUtils.deriveKey(
                props.data,
                dbData[0].id,
                dbData[0].productPricingBeanList[0].unitType,
                returnFlag
              );
              let position = SaleUtils.isProductExist(props.rawData, key);
              if (position >= 0) {
                await updateProduct(
                  position,
                  "addQty",
                  parseFloat(productBean.kitItems[i].quantity)
                );
              } else {
                rawData.push({
                  index: rawData.length,
                  productBean: dbData[0],
                  pricingBean: dbData[0].productPricingBeanList[0],
                  price: dbData[0].productPricingBeanList[0].price,
                  qty: parseFloat(productBean.kitItems[i].quantity),
                  returnFlag: returnFlag,
                  discountFlag: returnFlag ? false : productBean.isDiscounted,
                  key: key,
                  exTax: extax,
                  saleItemNote: "",
                });
              }
            }
          }
        } else {
          rawData.push({
            index: rawData.length,
            productBean: productBean,
            pricingBean: pricingBean,
            price: price,
            qty: qty,
            returnFlag: returnFlag,
            discountFlag: returnFlag ? false : productBean.isDiscounted,
            key: key,
            exTax: extax,
            saleItemNote: "",
          });
        }
      } else {
        console.log("PRICING BEAN NOT FOUND!");
      }
    }
    props.setRawSale(rawData);
    rawData.map((item) => {
      updateSaleData(rawData, item.key);
    });
  }

  function getPricingFromUnitType(productBean, unitType) {
    for (let pricing of productBean.productPricingBeanList) {
      if (pricing.unitType === unitType) {
        return pricing;
      }
    }
    return null;
  }

  function updateCustomerPriceLevel(customerData) {
    var rawData = [...props.rawData];
    for (let i = 0; i < rawData.length; i++) {
      let pricingBean = rawData[i].pricingBean;
      if (
        customerData != null &&
        customerData != "" &&
        customerData != undefined &&
        customerData.pricingLevel != null &&
        customerData.pricingLevel != undefined &&
        pricingBean.pricingLevelBeanList != null &&
        Array.isArray(pricingBean.pricingLevelBeanList) &&
        pricingBean.pricingLevelBeanList[customerData.pricingLevel] != null
      ) {
        let rebuildPriceObj = { ...pricingBean };
        rebuildPriceObj.cost =
          pricingBean.pricingLevelBeanList[customerData.pricingLevel].cost;
        rebuildPriceObj.margin =
          pricingBean.pricingLevelBeanList[customerData.pricingLevel].margin;
        rebuildPriceObj.marginPer =
          pricingBean.pricingLevelBeanList[customerData.pricingLevel].marginPer;
        rebuildPriceObj.price =
          pricingBean.pricingLevelBeanList[customerData.pricingLevel].price;

        rawData[i].pricingBean = rebuildPriceObj;
        rawData[i].price =
          pricingBean.pricingLevelBeanList[customerData.pricingLevel].price;
      }
    }
    props.setRawSale(rawData);

    rawData.map((item) => {
      updateSaleData(rawData, item.key);
    });
  }

  function removeItem() {
    // //console.log("current selection: " + getCurrentRow());
    var index = props.rawData.findIndex(function (item, i) {
      return item.key === props.data[getCurrentRow()][9].info.key;
    });
    removeRawData(index);
  }

  function removeRawData(index) {
    let rawData = props.rawData;
    rawData.splice(index, 1);
    props.setRawSale(rawData);
    if (rawData.length === 0) updateSaleData(rawData, null);
    else if (index === 0) updateSaleData(rawData, rawData[index].key);
    else updateSaleData(rawData, rawData[index - 1].key);
  }

  function moveUp() {
    let position = getCurrentRow();
    if (position > 0) {
      var data = [...props.data];
      resetSelection(data, position - 1);
      props.setSaleData(data);
      if (props.changeReturnFlag) props.changeReturnFlag(false);
    }
  }
  function moveDown() {
    let position = getCurrentRow();

    if (position < props.data.length - 1) {
      var data = [...props.data];
      resetSelection(data, position + 1);
      props.setSaleData(data);
      if (props.changeReturnFlag) props.changeReturnFlag(false);
    }
  }

  async function preProcess(productBean, pricingBean, barcode, rowId) {
    if (barcode) {
      let allCats = await db.category.toArray();
      let deliCodes = {};
      for (let cat of allCats) {
        if (cat.deliItem) {
          deliCodes[cat.groupCode] = cat;
        }
      }

      let dbData = await db.setting.where("sKey").equals("deli").toArray();
      let deliSetting = JSON.parse(dbData[0].sValue);
      let deliBarcodeLength =
        parseInt(deliSetting.deptCodelen) +
        parseInt(deliSetting.itemCodelen) +
        parseInt(deliSetting.valueLength) +
        parseInt(deliSetting.parityLength);
      let isDeli = false;
      if (deliBarcodeLength == barcode.length) {
        let deptCode = barcode.substring(0, parseInt(deliSetting.deptCodelen));

        let itemCode = barcode.substring(
          parseInt(deliSetting.deptCodelen),
          parseInt(deliSetting.deptCodelen) + parseInt(deliSetting.itemCodelen)
        );
        let value = barcode.substring(
          parseInt(deliSetting.deptCodelen) + parseInt(deliSetting.itemCodelen),
          parseInt(deliSetting.deptCodelen) +
            parseInt(deliSetting.itemCodelen) +
            parseInt(deliSetting.valueLength)
        );

        let deptid = deliCodes[deptCode] ? deliCodes[deptCode].id : null;
        let dbData = await db.product
          .where({ barcodeList: itemCode, deptId: deptid })
          .toArray();

        if (dbData.length > 0) {
          isDeli = true;
          let productBean = dbData[0];
          let pricingBean = getPricingFromBarcode(productBean, itemCode);
          if (productBean.isOpenPrice) {
            showOpenPriceDialog(productBean, pricingBean);
          } else {
            let key = SaleUtils.deriveKey(
              props.data,
              productBean.id,
              pricingBean.unitType,
              props.returnFlag,
              "DELI" + (props.data.length + 1)
            );

            let qty = 1;
            let price = pricingBean.price;

            if (productBean.uom === "W") {
              qty = value / 1000;
            }
            if (productBean.uom === "P") {
              price =
                value /
                parseInt("1" + "0".repeat(props.context.store.currencyDecimal));
            }
            if (productBean.uom === "Q") {
              qty = parseInt(value);
            }

            addProductOuter(
              productBean,
              pricingBean,
              price,
              qty,
              props.returnFlag,
              key,
              rowId
            );
          }
        }
      }
      if (!isDeli) {
        let dbData = await db.product
          .where("barcodeList")
          .equals(barcode)
          .toArray();

        if (dbData.length == 0) {
          //Lets Try with product code
          dbData = await db.product.where("code").equals(barcode).toArray();
          if (dbData.length == 0) {
            if (props.saleSetting.itemNotFoundAlert) {
              props.setAlert({
                show: true,
                title: "Alert!",
                message: translate("Item Not Found"),
                sound: true,
              });
            } else {
              props.showMessage("warning", translate("Item Not Found"));
            }
          } else {
            productBean = dbData[0];
            pricingBean = productBean.productPricingBeanList[0];

            let key = SaleUtils.deriveKey(
              props.data,
              productBean.id,
              pricingBean.unitType,
              props.returnFlag
            );

            let position = SaleUtils.isProductExist(props.rawData, key);
            if (position >= 0) {
              updateProduct(position, "addQty", 1);
            } else {
              addProductOuter(
                productBean,
                pricingBean,
                pricingBean.price,
                1,
                props.returnFlag,
                key,
                rowId
              );
            }
          }
        } else {
          productBean = dbData[0];
          /*if (productBean.isOpenPrice) {
            showOpenPriceDialog(productBean, pricingBean);
          } else {*/
          pricingBean = getPricingFromBarcode(productBean, barcode);
          let key = SaleUtils.deriveKey(
            props.data,
            productBean.id,
            pricingBean.unitType,
            props.returnFlag
          );

          let position = SaleUtils.isProductExist(props.rawData, key);
          if (position >= 0) {
            updateProduct(position, "addQty", 1);
          } else {
            addProductOuter(
              productBean,
              pricingBean,
              pricingBean.price,
              1,
              props.returnFlag,
              key,
              rowId
            );
          }
          // }
        }
      }
    } else {
      let key = SaleUtils.deriveKey(
        props.data,
        productBean.id,
        pricingBean.unitType,
        props.returnFlag
      );

      let position = SaleUtils.isProductExist(props.rawData, key);
      if (position >= 0) {
        updateProduct(position, "addQty", 1);
      } else {
        addProductOuter(
          productBean,
          pricingBean,
          pricingBean.price,
          1,
          props.returnFlag,
          key,
          rowId
        );
      }
    }
  }

  async function updateProduct(position, eventType, value) {
    let result = await SaleUtils.updateProduct(
      position,
      eventType,
      value,
      props.rawData,
      props.data,
      props.context,
      props.setAlert,
      translate
    );
    if (result) {
      props.setRawSale(result.rawData);
      updateSaleData(result.rawData, result.key);
    }
  }
  /*function getPositionByKeyFromInternalList(data, key) {
    let ix = 0;
    for (let d of data) {
      if (key === d.key) return ix;
      ix++;
    }
    return null;
  }*/

  async function addProductOuter(
    productBean,
    pricingBean,
    price,
    qty,
    returnFlag,
    key,
    rowId
  ) {
    if (
      !(await SaleUtils.isSaleAllowed(
        props.saleSetting,
        props.setAlert,
        translate,
        props.context,
        productBean,
        pricingBean,
        null,
        null,
        null,
        returnFlag
      ))
    ) {
      return;
    }

    if (productBean.isOpenQty) {
      props.setPricingBean(pricingBean);
      props.setProductBean(productBean);
      props.setCurrentScreen("open_qty_price");
      props.setProductKey(key);
    } else if (productBean.productType && productBean.productType == "S") {
      props.setPricingBean(pricingBean);
      props.setProductBean(productBean);
      props.setServiceDataMode("create");
      //setShowServiceWindow(true);
      props.setCurrentScreen("service_details");
    } else if (productBean.isOpenPrice) {
      props.setPricingBean(pricingBean);
      props.setProductBean(productBean);
      props.setProductKey(key + new Date().getTime());
      props.setCurrentScreen("open_qty_price");
    } else {
      SaleUtils.addProductNew(
        props.rawData,
        props.setRawSale,
        props.setSaleData,
        props.colorPallet,
        props.context,
        productBean,
        pricingBean,
        price,
        qty,
        returnFlag,
        key,
        false,
        null,
        props.changeReturnFlag,
        rowId
      );
    }
  }

  async function updateSaleData(data, key, context) {
    let saleData = await SaleUtils.updateSaleData(
      data,
      key,
      props.context.store.currencyDecimal,
      props.colorPallet,
      null,
      props.context
    );

    props.setSaleData(saleData[0]);
    if (props.changeReturnFlag) props.changeReturnFlag(false);
  }

  function isDeli(barcode) {
    for (let code of props.context.deliCodes) {
      //console.log(code);
    }
    return false;
  }
  function getPricingFromBarcode(productBean, barcode) {
    for (let pricing of productBean.productPricingBeanList) {
      for (let barcodeBean of pricing.productBarcodeBeanList) {
        if (barcodeBean.barcode == barcode) {
          return pricing;
        }
      }
    }
  }

  function getCurrentRow(value) {
    var data = [...props.data];
    let i = 0;
    for (let d of data) {
      if (d[9].info.selected) {
        return i;
      }
      i++;
    }
    return -1;
  }

  function showOpenPriceDialog() {}

  function resetSelection(data, rowIndex) {
    // props.setSelectedSaleItemIndex(rowIndex);
    for (let i = 0; i < data.length; i++) {
      if (rowIndex == i) {
        data[i][9].info.selected = true;
        data[i][5].focus = true;
      } else {
        data[i][9].info.selected = false;
        data[i][5].focus = false;
      }
    }
  }

  async function onViewProductImageClicked(tableMeta) {
    let productBean =
      tableMeta.tableData[tableMeta.rowIndex][9].info.productBean;
    let tempPreviewFileList = [];
    for (let i = 0; i < productBean.productFiles.length; i++) {
      let fileItem = productBean.productFiles[i];
      let fileData = null;
      let imageData = null;
      let dbData = await db.file.where("id").equals(fileItem.fileId).toArray();
      if (dbData[0] != null && dbData[0] != undefined) {
        fileData = dbData[0].fileData;
        imageData = dbData[0].imageData;
      }
      let item = {
        selected: i == 0 ? true : false,
        previewObj: imageData ? imageData : fileData,
        printObject: fileData,
        fileType: imageData ? "IMAGE" : fileItem.fileType,
        printFileType: fileItem.fileType,
      };
      tempPreviewFileList.push(item);
    }
    setPreviewFileList(tempPreviewFileList);
    setOpenFileViewWindow(true);
  }
  const desktopColumns = [
    {
      name: "sn",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "left", paddingLeft: 5 }}>
            {translate("S/N")}
          </div>
        ),
        display: "true",
        customBodyRenderLite: (dataIndex) => {
          return (
            <div style={{ background: props.data[dataIndex][0].color }}>
              {props.data[dataIndex][0].v}
            </div>
          );
        },
      },
    },
    {
      name: "code",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "left", paddingLeft: 5 }}>
            {translate("Code")}
          </div>
        ),
        display: "true",
        customBodyRenderLite: (ix) => (
          <div id={"table_row_" + ix}>{props.data[ix][1].v}</div>
        ),
      },
    },
    {
      name: "product",
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "left", paddingLeft: 5 }}>
            {translate("Product")}
          </div>
        ),
        customBodyRenderLite: (ix) => <div>{props.data[ix][2].v}</div>,
      },
    },
    {
      name: "price",
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right", paddingRight: 15 }}>
            {translate("Price")}
          </div>
        ),

        customBodyRenderLite: (ix) => (
          <div style={{ textAlign: "right", paddingRight: 10 }}>
            {props.data[ix][3].v}
          </div>
        ),
      },
    },
    {
      name: "uom",
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right", paddingRight: 15 }}>
            {translate("UOM")}
          </div>
        ),
        customBodyRenderLite: (ix) => (
          <div style={{ textAlign: "right", paddingRight: 10 }}>
            {props.data[ix][4].v}
          </div>
        ),
      },
    },
    {
      name: "qty",
      options: {
        filter: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right", paddingRight: 15 }}>
            {translate("Qty")}
          </div>
        ),
        sort: false,
        display: "true",
        customBodyRenderLite: (ix) => (
          <div style={{ textAlign: "right", paddingRight: 10 }}>
            {props.data[ix][5].v}
          </div>
        ),
      },
    },
    {
      name: "discount",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right", paddingRight: 15 }}>
            {translate("Disc%")}
          </div>
        ),
        display: "true",
        customBodyRenderLite: (ix) => (
          <div style={{ textAlign: "right", paddingRight: 10 }}>
            {props.data[ix][6].v}
          </div>
        ),
      },
    },
    {
      name: "tax",
      options: {
        filter: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right", paddingRight: 15 }}>
            {translate("Tax")}
          </div>
        ),
        sort: false,
        display: "true",
        customBodyRenderLite: (ix) => (
          <div style={{ textAlign: "right", paddingRight: 10 }}>
            {props.data[ix][7].v}
          </div>
        ),
      },
    },
    {
      name: "netAmount",
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right", paddingRight: 15 }}>
            {translate("Amount")}
          </div>
        ),
        customBodyRenderLite: (ix) => (
          <div
            style={{
              textAlign: "right",
              paddingRight: 10,
            }}
          >
            {props.data[ix][8].v}
          </div>
        ),
      },
    },
    {
      name: translate("..."),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return <div style={{ color: teal[700] }}>.</div>;
        },
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                sx={{ padding: 0 }}
                onClick={(event) => {
                  handleClick(event, tableMeta.tableData[tableMeta.rowIndex]);
                }}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id={"long-menu" + tableMeta.rowIndex}
                anchorEl={anchorEl}
                keepMounted
                open={menuOpen}
                onClose={handleClose}
              >
                {props.currentRow && props.currentRow[9].info.serviceMeta && (
                  <MenuItem
                    key={tableMeta.tableData[tableMeta.rowIndex] + "SR"}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      setAnchorEl(null);

                      props.setServiceDataMode("update");
                      props.setCurrentScreen("service_details");
                    }}
                  >
                    {translate("Modify SR")}
                  </MenuItem>
                )}

                <MenuItem
                  key={tableMeta.tableData[tableMeta.rowIndex] + "NOTE"}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setAnchorEl(null);

                    let position = SaleUtils.getCurrentRow(props.data);
                    if (position >= 0)
                      props.setValue(props.data[position][9].info.saleItemNote);
                    else props.setValue("");
                    props.setCurrentScreen("value_capture_note");
                  }}
                >
                  {translate("Note")}
                </MenuItem>
                {props.privileges.remove_buttun_allowed && (
                  <MenuItem
                    key={tableMeta.tableData[tableMeta.rowIndex] + "DELETE"}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      setAnchorEl(null);
                      removeItem();
                    }}
                  >
                    {translate("Delete")}
                  </MenuItem>
                )}
              </Menu>
            </div>
          );
        },
      },
    },
  ];

  function getMobileColumns(showActionCol, showPlusOrMinsus, showDetails) {
    let mobileColumns = [
      {
        name: "sn",
        options: {
          filter: false,
          sort: false,
          customHeadLabelRender: (value, tableMeta, updateValue) => (
            <div style={{ textAlign: "left", paddingLeft: 5 }}>
              {translate("S/N")}
            </div>
          ),
          display: "true",
          customBodyRenderLite: (dataIndex) => {
            return (
              <div style={{ background: props.data[dataIndex][0].color }}>
                {props.data[dataIndex][0].v}
              </div>
            );
          },
        },
      },
      {
        name: translate(props.context.appType === "R_POS" ? "Item" : "Product"),
        options: {
          filter: false,
          sort: false,
          customHeadLabelRender: (value, tableMeta, updateValue) => {
            return (
              <div style={{ textAlign: "left", paddingLeft: 5 }}>
                {translate(
                  props.context.appType === "R_POS" ? "Item" : "Product"
                )}
              </div>
            );
          },
          display: "true",
          customBodyRender: (value, tableMeta, updateValue) => {
            let uom = tableMeta.tableData[tableMeta.rowIndex][9].info
              .productBean.uom
              ? tableMeta.tableData[tableMeta.rowIndex][9].info.productBean.uom
              : translate("Unit");
            let isProductImageAvilable =
              tableMeta.tableData[tableMeta.rowIndex][9].info.productBean
                .productFiles &&
              tableMeta.tableData[tableMeta.rowIndex][9].info.productBean
                .productFiles.length > 0
                ? true
                : false;
            return (
              <Grid container style={{ background: value.color }}>
                <Grid item xs={12}>
                  <div
                    style={{
                      paddingTop: showDetails ? "0px" : "6px",
                    }}
                  >
                    {isProductImageAvilable && (
                      <Tooltip title={translate("View Product Images")}>
                        <IconButton
                          color="secondary"
                          onClick={() => onViewProductImageClicked(tableMeta)}
                        >
                          <PermMediaOutlinedIcon
                            style={{
                              width: "15px",
                              height: "20",
                              color: "#084675",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                    {tableMeta.tableData[tableMeta.rowIndex][2].v}
                  </div>
                </Grid>
                {showDetails && (
                  <Grid item xs={12}>
                    <div style={{ fontSize: "0.7rem" }}>
                      {tableMeta.tableData[tableMeta.rowIndex][5].v} {uom} at{" "}
                      {
                        tableMeta.tableData[tableMeta.rowIndex][9].info
                          .retailSalePrice
                      }
                      /{uom}, Tax {tableMeta.tableData[tableMeta.rowIndex][7].v}
                      {parseFloat(
                        tableMeta.tableData[tableMeta.rowIndex][9].info
                          .discountAmount
                      ) > 0 && (
                        <div>
                          {
                            <div style={{ fontWeight: "bold" }}>
                              {" "}
                              discount :{" "}
                              {
                                tableMeta.tableData[tableMeta.rowIndex][9].info
                                  .discountPer
                              }{" "}
                              {" %"}
                            </div>
                          }
                        </div>
                      )}
                    </div>
                  </Grid>
                )}
              </Grid>
            );
          },
        },
      },
    ];

    if (showPlusOrMinsus) {
      mobileColumns.push({
        name: translate("Qty"),
        options: {
          filter: false,
          sort: false,
          customHeadLabelRender: (value, tableMeta, updateValue) => {
            return (
              <div style={{ textAlign: "center", paddingRight: 10 }}>
                {translate("Qty")}
              </div>
            );
          },
          display: "true",
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div
                style={{
                  background: value.color,
                  textAlign: "center",
                  fontSize: "1.10rem",
                }}
              >
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <IconButton
                          aria-label="delete"
                          sx={{ color: red[900], padding: 0 }}
                          onClick={() => {
                            let newQty =
                              parseFloat(
                                tableMeta.tableData[tableMeta.rowIndex][5].v
                              ) - 1;
                            if (newQty > 0)
                              props.onChangeValueEvent(
                                newQty,
                                "updateQty",
                                tableMeta.rowIndex
                              );
                          }}
                        >
                          <RemoveIcon style={{ fontSize: 35 }} />
                        </IconButton>
                      </td>
                      <td> {tableMeta.tableData[tableMeta.rowIndex][5].v}</td>
                      <td>
                        {" "}
                        <IconButton
                          aria-label="delete"
                          size="40"
                          sx={{ color: red[900], padding: 0 }}
                          onClick={() => {
                            let newQty =
                              parseFloat(
                                tableMeta.tableData[tableMeta.rowIndex][5].v
                              ) + 1;
                            if (newQty > 0)
                              props.onChangeValueEvent(
                                newQty,
                                "updateQty",
                                tableMeta.rowIndex
                              );
                          }}
                        >
                          <AddIcon style={{ fontSize: 35 }} />
                        </IconButton>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          },
        },
      });
    }

    mobileColumns.push({
      name: translate("Amount"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right", paddingRight: 10 }}>
              {translate("Amount")}
            </div>
          );
        },
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                background: value.color,
                textAlign: "right",
                fontSize: "1rem",
              }}
            >
              {tableMeta.tableData[tableMeta.rowIndex][8].v}
            </div>
          );
        },
      },
    });
    if (showActionCol) {
      mobileColumns.push({
        name: translate("Action"),
        options: {
          filter: false,
          sort: false,
          customHeadLabelRender: (value, tableMeta, updateValue) => {
            return <div></div>;
          },
          display: "true",
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  sx={{ padding: 0 }}
                  onClick={(event) => {
                    handleClick(event, tableMeta.tableData[tableMeta.rowIndex]);
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id={"long-menu" + tableMeta.rowIndex}
                  anchorEl={anchorEl}
                  keepMounted
                  open={menuOpen}
                  onClose={handleClose}
                >
                  {props.currentRow && props.currentRow[9].info.serviceMeta && (
                    <MenuItem
                      key={tableMeta.tableData[tableMeta.rowIndex] + "SR"}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setAnchorEl(null);

                        props.setServiceDataMode("update");
                        props.setCurrentScreen("service_details");
                      }}
                    >
                      {translate("Modify SR")}
                    </MenuItem>
                  )}

                  <MenuItem
                    key={tableMeta.tableData[tableMeta.rowIndex] + "NOTE"}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      setAnchorEl(null);

                      let position = SaleUtils.getCurrentRow(props.data);
                      if (position >= 0)
                        props.setValue(
                          props.data[position][9].info.saleItemNote
                        );
                      else props.setValue("");
                      props.setCurrentScreen("value_capture_note");
                    }}
                  >
                    {translate("Note")}
                  </MenuItem>
                  {props.privileges.remove_buttun_allowed && (
                    <MenuItem
                      key={tableMeta.tableData[tableMeta.rowIndex] + "DELETE"}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setAnchorEl(null);
                        removeItem();
                      }}
                    >
                      {translate("Delete")}
                    </MenuItem>
                  )}
                  {props.privileges.qty_buttun_allowed && (
                    <MenuItem
                      key={tableMeta.tableData[tableMeta.rowIndex] + "QTY"}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setAnchorEl(null);
                        props.setValue("");
                        props.setCurrentScreen("value_capture_qty");
                      }}
                    >
                      {translate("Change Quantity")}
                    </MenuItem>
                  )}
                  {props.privileges.price_buttun_allowed && (
                    <MenuItem
                      key={tableMeta.tableData[tableMeta.rowIndex] + "PRICE"}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setAnchorEl(null);
                        props.setValue("");
                        props.setCurrentScreen("value_capture_price");
                      }}
                    >
                      {translate("Change Price")}
                    </MenuItem>
                  )}
                  {props.saleType === "SALE" &&
                    props.privileges.price_buttun_allowed && (
                      <MenuItem
                        key={tableMeta.tableData[tableMeta.rowIndex] + "DISC"}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          setAnchorEl(null);
                          props.setValue("");
                          props.setCurrentScreen("value_capture_disc");
                        }}
                      >
                        {translate("Discount")}
                      </MenuItem>
                    )}
                </Menu>
              </div>
            );
          },
        },
      });
    }
    return mobileColumns;
  }

  const options = {
    textLabels: {
      body: {
        noMatch:
          props.saleType != "SERVICE"
            ? translate("Search or Scan the product")
            : translate("Search for Service"),
      },
    },

    filterType: "checkbox",
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    customToolbar: null,
    title: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    pagination: false,
    responsive: "standard",
    tableBodyHeight: getTableBodyHeight(),
    setRowProps: (row, dataIndex, rowIndex) => {
      if (props.data[rowIndex][9].info.selected) {
        return {
          style: { background: "#FFCC99" },
        };
      }
    },
    onRowClick: (rowData, rowMeta, rowIndex) => {
      var data = [...props.data];
      resetSelection(props.data, rowMeta.rowIndex);
      props.setSaleData(data);
    },
  };

  useEffect(() => {
    let pos = getCurrentRow();

    const next = inputRef.current[pos];
    if (next) {
      next.focus();
    }

    scollToActiveElem();
  }, [props.data]);
  useEffect(() => {
    //preProcess(null, null, "8906067961266");
    //preProcess(null, null, "9912345050001");
    //preProcess(null, null, "8906057531295");
    // scollToActiveElem();
  }, []);

  function getTableBodyHeight() {
    if (props.context.appType === "R_POS") {
      let size = 360;
      if (props.workflowStatus == "NEW") {
        size = 330;
        if (props.currentMenu == "dineIn") {
          size = 350;
        }
        if (props.currentMenu == "delivery") {
          size = 390;
        }
      } else {
        size = 390;
        if (props.currentMenu == "dineIn") {
          size = 410;
        }
        if (props.currentMenu == "delivery") {
          size = 450;
        }
      }
      if (props.context.appMode == "mobile") {
        size = 220;
      }
      return (
        (
          AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode)
            .h - size
        ).toString() + "px"
      );
    }
    if (props.context.appMode === "desktop-pos") {
      if (props.terminalBean.saleMode == "TOUCH_POS_TILE") {
        return (
          (
            AgentUtils.getWindowDimensionsExAppBarsDualMode(
              props.context.appMode
            ).h - (props.saleType === "SERVICE" ? 225 : 165)
          ).toString() + "px"
        );
      }

      return (
        (
          AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode)
            .h - (props.saleType === "SERVICE" ? 210 : 180)
        ).toString() + "px"
      );
    } else {
      return (
        (
          AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode)
            .h - (props.saleType === "SERVICE" ? 260 : 160)
        ).toString() + "px"
      );
    }
  }

  function scollToActiveElem() {
    let i = 0;
    if (props.terminalBean.saleMode != "KEYBOARD_TRADING") {
      for (var e of props.data) {
        if (e[9].info.selected) {
          props.setCurrentRow(e);
          const timer = setTimeout(() => {
            const node = document.getElementById("table_row_" + (i - 1));
            if (node) node.scrollIntoView();
            else {
              const node = document.getElementById("table_row_" + i);
              if (node) node.scrollIntoView();
            }
          }, 25);
          return () => clearTimeout(timer);
        }
        i++;
      }
    }
  }
  /*function getColumn() {
    if (props.context.store.tradingMode) {
      return tradingColumns;
    } else {
      if (props.context.appMode === "desktop-pos") return desktopColumns;
      else return mobileColumns;
    }
  }*/

  function getCols() {
    if (props.context.appType === "R_POS") {
      if (props.context.appMode === "mobile")
        return getMobileColumns(true, true, false);
      else return getMobileColumns(false, false, true);
    }
    if (props.context.appMode === "desktop-pos") {
      if (props.terminalBean.saleMode == "TOUCH_POS_TILE") {
        return getMobileColumns(false, false, true);
      } else {
        return desktopColumns;
      }
    } else {
      return getMobileColumns(true, false, true);
    }
  }

  function getTheme() {
    if (props.context.appType === "R_POS") {
      if (props.context.appMode === "mobile") return theme;
      else return r_pos_desktop_theme;
    }
    return theme;
  }

  function getContent() {
    if (props.hideDisplay) {
      return <div></div>;
    }
    return (
      <div style={{ paddingTop: 5, paddingBottom: 5 }}>
        <ThemeProvider theme={getTheme()}>
          <MUIDataTable
            data={props.data}
            columns={getCols()}
            options={options}
          />
        </ThemeProvider>
      </div>
    );
  }
  return (
    <div>
      {props.terminalBean.saleMode != "KEYBOARD_TRADING" && getContent()}
    </div>
  );
}
